export const APP_TITLE = "DynamoDB Dashboard";

export const APP_DESCRIPTION =
  "Monitor API requests and errors captured in PostgreSQL.";

export const JSON_VIEWER_MAX_DEPTH = 12;
export const JSON_VIEWER_MAX_NODES = 4000;

export const ERROR_DETECTION_MAX_DEPTH = 8;

/**
 * Default createdAt lookback helper (unused for auto-filtering — dates are
 * only applied when the user sets them explicitly). Kept for optional tooling.
 */
export const DEFAULT_LOOKBACK_DAYS = 1;

/**
 * Dashboard default window when no Created/Updated filter is set.
 * Keeps /dashboard fast while still reflecting real recent PostgreSQL data.
 */
export const ANALYTICS_DEFAULT_LOOKBACK_DAYS = 2;

/**
 * Page size used while walking filter-option / count scans. Round/record
 * caps were removed — collection continues until DynamoDB reports no more data.
 */
export const FILTER_OPTIONS_PAGE_SIZE = 100;
/** @deprecated Kept for imports; full scans no longer stop early on record count. */
export const FILTER_OPTIONS_MAX_RECORDS = Number.MAX_SAFE_INTEGER;
/** @deprecated Kept for imports; full scans no longer stop early on round count. */
export const FILTER_OPTIONS_MAX_ROUNDS = Number.MAX_SAFE_INTEGER;

/**
 * Upper bound on how many records an on-demand analytics computation will
 * sample across paginated Query calls before stopping and flagging the
 * result as potentially partial. Keeps summary/trend/breakdown requests
 * bounded even for very large filtered result sets.
 */
export const ANALYTICS_MAX_RECORDS = 8000;
export const ANALYTICS_MAX_ROUNDS = 40;
/** Max Query pages walked per DateIndex day while building an analytics sample. */
export const ANALYTICS_MAX_PAGES_PER_DAY = 20;

/**
 * Route Analytics response cache TTL. Identical filter requests reuse the last result.
 */
export const ROUTE_ANALYTICS_CACHE_TTL_MS = 30 * 60 * 1000;

/** One-shot Route Details load: max rows returned from PostgreSQL in a single query. */
export const ROUTE_DETAILS_FETCH_ALL_MAX = 250_000;

export const CURSOR_VERSION = 1 as const;

export const LOCAL_STORAGE_KEYS = {
  theme: "dynamodb-dashboard:theme",
  sidebarCollapsed: "dynamodb-dashboard:sidebar-collapsed",
  columnVisibility: "dynamodb-dashboard:column-visibility",
  pageSize: "dynamodb-dashboard:page-size",
  routeGrouping: "dynamodb-dashboard:route-grouping",
} as const;

export const NAV_ITEMS = [
  { href: "/logs", label: "Logs" },
  { href: "/activity", label: "Realtime" },
] as const;
